package com.imobly.imobly.viewmodel

import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.mutableStateListOf
import androidx.lifecycle.ViewModel
import androidx.navigation.NavHostController
import com.imobly.imobly.domain.Payment
import androidx.compose.material3.SnackbarHostState
import androidx.lifecycle.viewModelScope
import com.imobly.imobly.api.createHttpClient
import com.imobly.imobly.api.dto.ErrorDTO
import com.imobly.imobly.api.dto.Ok
import com.imobly.imobly.api.dto.StatusInstallmentDTO
import com.imobly.imobly.api.httpclient.PaymentHttpClient
import com.imobly.imobly.domain.Lease
import com.imobly.imobly.domain.MonthlyInstallment
import com.imobly.imobly.domain.enums.PaymentStatusEnum
import kotlinx.coroutines.launch

class PaymentViewModel(private val navController: NavHostController) : ViewModel() {
    val payment = mutableStateOf(Payment())

    val selectedInstallments = mutableStateListOf<MonthlyInstallment>()

    val snackMessage = mutableStateOf(SnackbarHostState())

    val searchText = mutableStateOf("")

    var currentLeaseId: String? = null
    val currentPage = mutableStateOf(0)
    val selectedStatus = mutableStateOf<PaymentStatusEnum?>(null)

    fun loadPage(page: Int) {
        if (currentLeaseId == null) return
        viewModelScope.launch {
            onLoadingState.value = true
            val httpClient = PaymentHttpClient(createHttpClient())
            try {
                val result = httpClient.searchByLeaseId(currentLeaseId!!, page, selectedStatus.value)
                payment.value = result
                currentPage.value = page
                clearSelection()
            } catch (e: Exception) {
                messageError.value = "Erro ao carregar página: ${e.message}"
            } finally {
                onLoadingState.value = false
            }
        }
    }

    fun setStatusFilter(status: PaymentStatusEnum?) {
        selectedStatus.value = if (selectedStatus.value == status) null else status
        loadPage(0)
    }

    fun toggleSelection(installment: MonthlyInstallment) {
        if (selectedInstallments.contains(installment)) {
            selectedInstallments.remove(installment)
        } else {
            selectedInstallments.add(installment)
        }
    }

    fun clearSelection() {
        selectedInstallments.clear()
    }

    fun changeSearchText(text: String) {
        searchText.value = text
    }

    val onLoadingState = mutableStateOf(false)

    val messageError = mutableStateOf("")

    private val inputErrors = mutableMapOf<String, String>()

    fun whenStartingThePage() {
        messageError.value = ""
        inputErrors.clear()
        onLoadingState.value = false
        selectedInstallments.clear()
    }

    fun updateSelectedStatus(newStatus: PaymentStatusEnum) {
        viewModelScope.launch {
            onLoadingState.value = true
            val httpClient = PaymentHttpClient(createHttpClient())
            if (payment.value.id != null && selectedInstallments.isNotEmpty()) {
                val dtoList = selectedInstallments.map { StatusInstallmentDTO(dueDate = it.dueDate, status = newStatus) }
                val response = httpClient.updateStatus(payment.value.id!!, dtoList)
                onLoadingState.value = false
                when (response) {
                    is Ok -> {
                        val updatedInstallments = payment.value.installments.map { inst ->
                            if (selectedInstallments.any { it.dueDate == inst.dueDate }) {
                                inst.copy(status = newStatus)
                            } else {
                                inst
                            }
                        }
                        payment.value = payment.value.copy(installments = updatedInstallments)
                        whenStartingThePage()
                        snackMessage.value.showSnackbar("Status das parcelas atualizado!")
                    }
                    is ErrorDTO -> {
                        messageError.value = response.message
                    }
                }
            } else {
                onLoadingState.value = false
                messageError.value = "Selecione ao menos uma parcela."
            }
        }
    }

    fun goToHome() {
        navController.navigate("home")
    }

    fun goToShowPayments() {
        navController.navigate("showpayments")
    }

    fun goToShowLeases() {
        navController.navigate("showleases")
    }
}